"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtractorService = void 0;
const sheet_db_1 = require("../sheet_db");
const open_ai_schema_object_1 = require("../ocr/open.ai.schema.object");
class ExtractorService {
    static extractKeys(schema, prefix = '') {
        const keys = [];
        if (!schema)
            return keys;
        const rawType = new Set(['string', 'number']);
        for (const key in schema) {
            const path = prefix ? `${prefix}.${key}` : key;
            const property = schema[key];
            if (property.type === 'object' && property.properties) {
                keys.push(...this.extractKeys(property.properties, path));
                continue;
            }
            if (rawType.has(property.type)) {
                keys.push({
                    type: property.type,
                    path,
                });
            }
        }
        return keys;
    }
    static mapSchemaPropertyToJSONSchema7(property) {
        switch (property.type) {
            case open_ai_schema_object_1.SchemaType.OBJECT:
                return {
                    type: 'object',
                    properties: Object.fromEntries(Object.entries(property.properties || {}).map(([k, v]) => [
                        k,
                        this.mapSchemaPropertyToJSONSchema7(v),
                    ])),
                };
            case open_ai_schema_object_1.SchemaType.STRING:
                return { type: 'string' };
            case open_ai_schema_object_1.SchemaType.NUMBER:
                return { type: 'number' };
            case open_ai_schema_object_1.SchemaType.ARRAY:
                return {
                    type: 'array',
                    items: property.items ? this.mapSchemaPropertyToJSONSchema7(property.items) : {},
                };
            case open_ai_schema_object_1.SchemaType.BOOLEAN:
                return { type: 'boolean' };
            default:
                return {};
        }
    }
    static mapJSonTypeToColumnType(type) {
        if (type === 'number')
            return sheet_db_1.ColumnType.NUMBER;
        if (type === 'string')
            return sheet_db_1.ColumnType.STRING;
        if (type === 'boolean')
            return sheet_db_1.ColumnType.BOOLEAN;
        return sheet_db_1.ColumnType.STRING;
    }
    static convertResponseSchemaToJSONSchema7(responseSchema) {
        if (!responseSchema || !responseSchema.properties) {
            return {};
        }
        const jsonSchema = {
            type: 'object',
            properties: {},
        };
        for (const key in responseSchema.properties) {
            const property = responseSchema.properties[key];
            jsonSchema.properties[key] = this.mapSchemaPropertyToJSONSchema7(property);
        }
        return jsonSchema;
    }
}
exports.ExtractorService = ExtractorService;
